import { FormikHelpers } from 'formik';
import { action } from 'mobx';
import { AccountEditBasic } from './model';
import { API_ACCOUNT_EDIT_BASIC } from 'api/endpoints';
import { ACCOUNTS_EDIT_VARIANT } from 'pages/Accounts/Edit/accountEditRoutes';
import history from 'helpers/routerHistory';
import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';

export class WorkflowBasicStore extends FormStore<AccountEditBasic> {
  constructor(rootStore: RootStore, accountId: string) {
    super(rootStore);
    this.rootStore = rootStore;
    this.accountId = accountId;
  }

  @action
  getAccountBasic = (title?: string) => {
    this.data = JSON.parse(JSON.stringify(this.rootStore.stores.editAccountStore.data));
    if (this.data && title) this.data.title = title;
  };

  handleSubmitBasic = async (values: AccountEditBasic, formikHelpers: FormikHelpers<AccountEditBasic>) => {
    const success = await this.submitData(API_ACCOUNT_EDIT_BASIC(this.accountId), values, {
      validationPrefixDepth: 2,
      formikHelpers,
      reset: false,
      singleValueResponse: true,
    });

    if (success) {
      await this.rootStore.stores.editAccountStore.fetchBasicData(this.accountId);
      success && history.push(ACCOUNTS_EDIT_VARIANT(this.accountId));
    }
  };
}
